import { SvgIcon, SvgIconProps } from '@mui/material'
import { FC } from 'react'
export const ButtonIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_2930_10863)">
        <path
          d="M2.49935 10C6.24935 10 9.99935 6.25002 9.99935 2.50002C9.99935 6.25002 13.7493 10 17.4993 10C13.7493 10 9.99935 13.75 9.99935 17.5C9.99935 13.75 6.24935 10 2.49935 10ZM1.66602 16.25C2.36018 16.25 3.74935 14.8609 3.74935 14.1667C3.74935 14.8609 5.13852 16.25 5.83268 16.25C5.13852 16.25 3.74935 17.6392 3.74935 18.3334C3.74935 17.6392 2.36018 16.25 1.66602 16.25ZM13.3327 4.16669C14.166 4.16669 15.8327 2.50002 15.8327 1.66669C15.8327 2.50002 17.4993 4.16669 18.3327 4.16669C17.4993 4.16669 15.8327 5.83335 15.8327 6.66669C15.8327 5.83335 14.166 4.16669 13.3327 4.16669Z"
          stroke="white"
          fill="transparent"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2930_10863">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  )
}
